import React, { useState, useEffect, useRef, memo } from "react";
import {
  HStack,
  VStack,
  Box,
  Button,
  Text,
  Pressable,
  Image,
  Divider,
  Tooltip,
  Spinner,
} from "native-base";
import {
  MoreHorizontalIcon,
  FavouriteIcon,
  AddIcon,
  GroupChatIcon,
} from "../../assets/icons/icon-assets";
import AVHeaderTitle from "./AVHeaderTitle";
import AVCoverPic from "./AVCoverPic";
import AVProfilePic from "./AVProfilePic";
import { useSelector, RootStateOrAny, useDispatch } from "react-redux";
import * as AV from "../../AVCore/AVCore";
import { setUser, setEntitydata } from "../../Redux/Actions/userActions";
import { useNavigate } from "react-router-dom";
import { Loc } from "../../App/Loc";
import { Dimensions } from "react-native";
import Dropdown from "../../assets/images/Drop.png";
import { useLocation, useParams } from "react-router-dom";
import Deleted from "../../assets/images/Deleted.png";
import { setConvo } from "../../Redux/Actions/convoActions";
import useConvoChat from "../../Hooks/useConvoChat";
import CustomToast from "../../Hooks/useCustomToast";
import { isWindows } from "react-device-detect";
import Offline from "react-offline";
import AVCancel from "../../components/common/AVCancel";
import AVInputtext from "../../components/AVInputtext";

declare function appendHelcimPayIframe(
  checkoutToken: string,
  showImmediately: boolean,
): void;

interface PaymentMessageData {
  hash: string;
  data: {
    amount: number | string;
    [key: string]: unknown;
  };
}

interface PaymentData {
  checkoutToken: string;
  data: PaymentMessageData;
}

const ProfileHeader = ({
  setIshuddleData,
  isCreate,
  isCreateDependents,
  setIsCreateDependents,
  isDeleted,
  isShowEdit,
  Entity,
  setEntity,
  EntityType,
  type,
  handleUpload,
  setIsShowEdit,
  profile,
  setProfile,
  googlemap,
  isAdminView,
  setIsStaffReq,
  setIsChildOrgReq,
  weatherURL,
  weather,
  Owner,
  setIsImagePopup,
  editAccess,
  HandleBlockUser,
  HandleUnBlockUser,
  HandleRestoreAccount,
  setIsConvoData,
  HandleUnFollowUser,
  setIsOpenConvo,
  setIsEditEntireSeries,
  isEditEntireSeries,
  seriesEvent,
  isRequestAgain,
  setIsRequestAgain,
  openPreview,
  isShowPayPopup,
  setIsShowPayPopup,
  setClickedUrl,
  setShowConfirmLinkPopup,
  isEntireSeriesAvailable = false,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location: any = useLocation();
  const params = useParams();
  let userconvo: any = useSelector(
    (state: RootStateOrAny) => state.convo.convo[0],
  );
  const dimensions = Dimensions.get("window");
  const isMobile = dimensions?.width <= 600 || false;
  const data = location?.state?.user;
  const currentUser = useSelector(
    (state: RootStateOrAny) => state.user.user[0],
  );
  const [isMyFavourite, setMyFavourite] = useState(false);
  const [isFavLoader, setIsFavLoader] = useState(false);
  var target: any = AV.AVEntity.getFk(Entity);
  const [isFollowing, setIsFollowing] = useState(false);
  const [requestSent, setRequestSent] = useState(false);
  const [followRequestSending, setFollowRequestSending] = useState(false);
  const entitydatalist = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );
  const pathName = window.location.pathname;
  const [isOpen, setIsOpen] = useState(false);
  const [isShowEditOccurence, setIsShowEditOccurence] = useState(false);
  const [isShowEditEntireSeries, setIsShowEditEntireSeries] = useState(false);
  let seriesEventData = Entity?.seriesEvents?.filter(
    (x) => x.id == params?.seriesId,
  )[0];
  const [isUpdateRSVPStatus, setIsUpdateRSVPStatus] = useState("");
  const [participantstatus, setParticipantStatus] = useState(
    seriesEventData?.participants &&
      seriesEventData?.participants[0]?.status?.trim()?.length > 0
      ? seriesEventData?.participants[0]?.status
      : !seriesEventData?.participants &&
          Entity?.participants
            ?.filter((x) => x.id === currentUser?.id)[0]
            ?.status?.trim()?.length > 0
        ? Entity?.participants?.filter((x) => x.id === currentUser?.id)[0]
            ?.status
        : "RSVP",
  );
  const [playersList, setPlayersList] = useState<any>([]);
  const [isActives, setIsActives] = useState(false);
  const [isBlock, setIsBlock] = useState(false);
  const userID = params?.userId;
  const region = params?.region;
  const [isBlockLoad, setIsBlockLoad] = useState<any>(false);
  const participantUser = Entity?.participants?.filter(
    (x) => x.id === currentUser?.id,
  );
  const [isShowPicker, setIsShowpicker] = useState(false);
  const [imageLoader, setImageLoader] = useState(false);
  const { handleGetGroupConvo, handleSendSingleChat } = useConvoChat();
  const [isLoad, setisLoad] = useState(false);
  const isMemberOfEntity = Entity?.members?.some(
    (x) => x?.id === currentUser?.id,
  );
  const isPlayerOfEntity = Entity?.players?.some(
    (x) => x?.id === currentUser?.id,
  );
  const isstaffOfEntity = Entity?.staff?.some((x) => x?.id === currentUser?.id);
  const [openMenu, setOpenMenu] = useState(false);
  const [isRsvpLoading, setIsRsvpLoading] = useState(false);
  const [isLoader, setLoader] = useState(false);
  const [payAmount, setPayAmount] = useState("");
  const [remainingAmount, setRemainingAmount] = useState<number>(0);
  const [pageLoader, setPageLoader] = useState(false);
  const [isLoadingPay, setIsLoadingPay] = useState(false);
  //const [isShowPayPopup, setIsShowPayPopup] = useState(false);
  const [isCollectFullyPaid, setIsCollectFullyPaid] = useState(false);

  //Follow and Unfollow
  const handleFollowProfile = async (type, name) => {
    var targetFK: any = AV.Person.getLink(Entity);
    targetFK.linkType = "Follow";
    switch (type) {
      case "follow":
        setFollowRequestSending(true);
        let result: any = await AV.Person.makeRequest(
          AV.Person.getLink(currentUser),
          targetFK,
        );
        if (result) {
          dispatch(setUser(result));
          if (result.follows.filter((x) => x.id === targetFK.id).length > 0) {
            setIsFollowing(true);
          } else {
            setRequestSent(true);
          }
        }
        setFollowRequestSending(false);
        break;
      case "unfollow":
        HandleUnFollowUser(AV.AVEntity.getFk(Entity), name);
        //setIsFollowing(false);
        setRequestSent(false);
        setFollowRequestSending(false);
        break;
    }
  };

  //Add and Remove Favourite
  const handleFavourite = async (type) => {
    setIsFavLoader(true);
    if (currentUser?.favs?.length >= 100) {
      let clientError = { message: "Favourite limit exceeds" };
      CustomToast({ clientError });
      setIsFavLoader(false);
      return;
    }

    let resp =
      type === "addFavourite"
        ? await AV.Person.addFavorite(
            AV.AVBase.getFk(currentUser),
            AV.AVEntity.getLink(Entity),
          ).then((x) => {
            dispatch(setUser(x));
          })
        : type === "removeFavourite"
          ? await AV.Person.removeFavorite(
              AV.AVBase.getFk(currentUser),
              AV.AVEntity.getLink(Entity),
            ).then((x) => {
              dispatch(setUser(x));
            })
          : "";
    type === "addFavourite" ? setMyFavourite(true) : setMyFavourite(false);
    setIsFavLoader(false);
  };

  const findPersonInChats = (conversations, personToCheck) => {
    return conversations?.find(
      (convo) =>
        convo?.subject === "" &&
        convo?.people?.some(
          (person) =>
            person?.id === personToCheck?.id &&
            person?.pk === personToCheck?.pk,
        ),
    );
  };

  const handleChat = async (item: any) => {
    setisLoad(true);
    let People: any = [];
    var sourceFK: any = AV.AVEntity.getLink(item);
    sourceFK.title = item?.name;
    People?.push(sourceFK);
    let valid = await findPersonInChats(userconvo, item);

    if (valid?.id !== undefined) {
      setIsConvoData(valid?.id);
      setisLoad(false);
      setIsOpenConvo(true);
      return;
    }

    let chatData = await handleSendSingleChat(People);
    if (chatData) {
      setIsConvoData(chatData?.id);
    }
    setisLoad(false);
    setIsOpenConvo(true);
  };

  const HandleGroupChat = async (type) => {
    setisLoad(true);
    if (Entity?.type == "Person") {
      handleChat(Entity);
      return;
    }

    let valid = type == "W" ? Entity.wConvo : type == "A" ? Entity?.aConvo : "";

    const isForceAllGroup =
      (Entity?.type === "PlayerOrg" &&
        Entity?.parent?.type === "Team" &&
        Entity?.subType === undefined) ||
      Entity?.type === "SchoolYear" ||
      ["Term", "Class", "GradClass", "MusicGroup"].includes(Entity?.subType);

    if (isForceAllGroup) {
      type = "A";
      valid = Entity?.aConvo;
    } else if (Entity?.subType === "Alumni") {
      type = "S";
      valid = Entity?.sConvo;
    }

    if (valid?.trim()?.length > 0 ? true : false) {
      //setIsConvoData( valid )
      let HuddleData: any = currentUser?.orgs?.filter((x) => x?.id == valid);
      navigate(`/huddles/${HuddleData[0]?.id ?? 1}`, {
        state: { HuddleData: HuddleData[0] },
      });
      return;
    }

    if (valid === "" || valid == undefined) {
      let Response: any = await AV.AVEntity.CreateGroupConvo(target, type);
      console.log("Response", Response);
      let Index = entitydatalist?.findIndex((x) => x?.id == Response?.id);
      if (Index !== -1) {
        entitydatalist[Index] = Response;
        setEntity(Response);
      }

      dispatch(setEntitydata(entitydatalist));
      const fk: any = {
        id: type == "W" ? Response.wConvo : type == "A" ? Response?.aConvo : "",
        pk: type == "W" ? Response.wConvo : type == "A" ? Response?.aConvo : "",
        region: Entity?.region,
        type: "GroupConvo",
      };

      setIsConvoData(fk?.id);
      let person = await AV.Person.getSelf(true);
      dispatch(setUser(person));

      setTimeout(() => {
        let HuddleData: any = person?.orgs?.filter((x) => x?.id == fk.id);
        navigate(`/huddles/${HuddleData[0]?.id ?? 1}`, {
          state: { HuddleData: HuddleData[0] },
        });
        setIshuddleData(HuddleData[0]);
      }, 1000);
    }
    setisLoad(false);
    //setIsOpenConvo(true);
  };

  //RSVP function
  const handleUpdateParticipant = async (participantStatus, isEntireSeries) => {
    setIsRsvpLoading(true);
    if (participantStatus == "Yes") {
      setParticipantStatus(Loc.currentLang.menu.attending);
    } else if (participantStatus == "No") {
      setParticipantStatus(Loc.currentLang.menu.notAttending);
    } else if (participantStatus == "Maybe") {
      setParticipantStatus(Loc.currentLang.menu.mayBe);
    }

    //setIsActives(!isActives);
    setParticipantStatus(participantStatus);
    //let occurId = Entity.series && !isEditEntireSeries ? Entity.id != Entity.series ? Entity.id : null : null;
    //let isSeries = isEditEntireSeries ? null : seriesEventData?.id;
    let isSeries = isEntireSeries ? null : seriesEventData?.id;
    //Entity.id = Entity.series ? Entity.series : Entity.id;
    setIsUpdateRSVPStatus("");
    await AV.Event.updateParticipant(
      AV.AVEntity.getFk(Entity),
      { ...AV.AVEntity.getFk(currentUser), status: participantStatus },
      isSeries,
    ).then(async (e: any) => {
      if (e) {
        let statusevent = e?.participants?.filter(
          (x) => x?.id === currentUser?.id,
        );
        if (statusevent?.length > 0)
          setParticipantStatus(
            statusevent[0]?.status ? statusevent[0]?.status : "RSVP",
          );
        setEntity(e);
        setPlayersList(e?.participants);
        let oldvalue = currentUser.events.filter((a) => a.id == e?.id);
        e.status = statusevent[0]?.status ? statusevent[0]?.status : "RSVP";
        currentUser.events[currentUser.events.indexOf(oldvalue[0])] = e;
        entitydatalist[
          entitydatalist.indexOf(entitydatalist?.find((x) => x?.id === e?.id))
        ] = e;
        dispatch(setEntitydata(entitydatalist));
        let finalUser = await AV.Person.getSelf(true);
        dispatch(setUser(finalUser));
        navigate(`/Events/${e?.id}/${e?.region}/${seriesEventData?.id}`, {
          state: { team: e, newEntity: true },
        });
      } else {
        Entity.status = participantStatus;
        Entity.participants = Entity.participants.map((event) => ({
          ...event,
          status: participantStatus,
        }));
        setEntity(Entity);
        setPlayersList(Entity?.participants);
        //setEventData(e);
        entitydatalist[
          entitydatalist.indexOf(
            entitydatalist?.find((x) => x?.id === Entity?.id),
          )
        ] = Entity;
        dispatch(setEntitydata(entitydatalist));
        let finalUser = await AV.Person.getSelf(true);
        dispatch(setUser(finalUser));
        navigate(`/Events/${Entity?.id}/${Entity?.region}/${e?.seriesId}`, {
          state: { team: Entity },
        });
      }
    });
    setIsRsvpLoading(false);
  };

  const menuRef = useRef(null);
  useOutsideAlerter(menuRef);

  //Hook that alerts clicks outside of the passed ref
  function useOutsideAlerter(ref) {
    useEffect(() => {
      // Alert if clicked on outside of element
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsActives(false);
          setIsOpen(false);
          setOpenMenu(false);
          setIsShowEditOccurence(false);
          setIsShowEditEntireSeries(false);
          setIsUpdateRSVPStatus("");
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      //if (seriesEventData) {
      //  seriesEvent.location = seriesEventData?.location ? seriesEventData?.location : Entity?.location;
      //}
      const following = currentUser?.follows?.filter(
        (item) => item?.id === Entity?.id,
      );
      const requests = currentUser?.myRequests?.filter(
        (item) => item?.target?.id === Entity?.id && item?.type === "Follow",
      );
      const Blocked = currentUser?.blocked;
      following?.length > 0 ? setIsFollowing(true) : setIsFollowing(false);
      requests?.length > 0 ? setRequestSent(true) : setRequestSent(false);
      if (currentUser?.favs?.filter((x) => x?.id === Entity?.id)[0]) {
        setMyFavourite(true);
      } else {
        setMyFavourite(false);
      }

      Blocked?.filter((item) => item?.id === Entity?.id).length > 0
        ? setIsBlock(true)
        : setIsBlock(false);

      // Pet Present
      if (Entity?.type === "Pet") {
        setIsFollowing(
          currentUser?.wards?.some(
            (item) => item?.id === Entity?.id && Entity?.type === "Pet",
          ) || following?.length > 0,
        );
      }

      if (Entity?.type === "Collect") {
        const userParticipant = Entity?.participants?.find(
          (x) => x?.id === currentUser?.id,
        );

        if (userParticipant) {
          const isPaid = userParticipant?.amount === Entity?.goal;
          setIsCollectFullyPaid(!!isPaid);

          const remaining =
            (userParticipant?.goalAmount ?? 0) - (userParticipant?.amount ?? 0);
          setRemainingAmount(Math.max(remaining, 0));
          setPayAmount(String(Math.max(remaining, 0)));
        } else {
          setPayAmount("0");
          setRemainingAmount(0);
          setIsCollectFullyPaid(true);
        }
      }
    }
    return () => {
      isMounted = false; // Set the flag to false when the component is unmounted
      // Cancel subscriptions or perform any cleanup tasks here
    };
  }, [Entity, currentUser]);

  // sub components
  const RenderRsvp = ({ entity }: { entity: any }) => {
    const params: any = useParams();

    let isEventOwner = true;
    let participantStatus = "";
    const entireParticipant =
      entity?.participants?.find((p) => p?.id === currentUser?.id) || null;
    seriesEventData =
      entity?.seriesEvents?.find((p) => p?.id === params.seriesId) || null;
    let isOccEvent = !(
      entity?.eventType === "Social" ||
      entity?.eventType === "Game" ||
      ((entity?.eventType === "Meeting" || entity?.eventType === "Practice") &&
        entity?.seriesEvents?.length === 0)
    );

    let occParticipant: AV.ITypeLink | null = null;
    if (isOccEvent) {
      occParticipant =
        seriesEventData?.participants?.find((p) => p?.id === currentUser?.id) ||
        null;
      participantStatus =
        seriesEventData?.status ||
        occParticipant?.status ||
        entireParticipant?.status ||
        null;
      isEventOwner =
        entireParticipant?.linkType === "Owner" ||
        entireParticipant?.linkType === "Staff" ||
        occParticipant?.linkType === "Owner" ||
        occParticipant?.linkType === "Staff";
    } else {
      participantStatus = entireParticipant?.status || null;
      isEventOwner =
        entireParticipant?.linkType === "Owner" ||
        entireParticipant?.linkType === "Staff";
    }

    let isCanceled = entity?.status
      ? entity?.status === "Canceled"
        ? true
        : participantStatus
          ? participantStatus === "Canceled"
          : false
      : false;

    let isParticipantPercent = entireParticipant?.id || occParticipant?.id;

    const handleUncancelEvent = async () => {
      try {
        setLoader(true);

        if (
          Entity?.status !== "Canceled" &&
          params?.seriesId !== "undefined" &&
          params?.seriesId !== undefined &&
          params?.seriesId
        ) {
          let fk = {
            id: Entity.series,
            pk: Entity.series.slice(-4),
            region: Entity.region,
            type: Entity.type,
          };
          await AV.Event.unCancelSeries(fk, params?.seriesId);
          // Find the index of the target entity in the entitydatalist
          const entityIndex = entitydatalist.findIndex(
            (x) => x?.id === Entity?.id,
          );

          // Check if the entity exists
          if (entityIndex !== -1) {
            // Get the specific entity
            const event = entitydatalist[entityIndex];

            // Find the index of the specific seriesEvent within the event
            const seriesEventIndex = event.seriesEvents.findIndex(
              (se) => se?.id === params?.seriesId,
            );

            // If the seriesEvent is found, update its status
            if (seriesEventIndex !== -1) {
              // Update the seriesEvent's status
              event.seriesEvents[seriesEventIndex] = {
                ...event.seriesEvents[seriesEventIndex],
                status: "",
              };

              // Update the entity in the entitydatalist
              const updatedEntitydatalist = [...entitydatalist];
              updatedEntitydatalist[entityIndex] = event;
              setEntity(event);
              // Dispatch the updated entitydatalist
              dispatch(setEntitydata(updatedEntitydatalist));
              navigate(
                `/Events/${Entity?.id}/${Entity?.region}/${params?.seriesId}`,
                { state: { team: Entity } },
              );
            }
          }

          setEntity(Entity);
          setLoader(false);
          setIsShowEdit(false);
        } else {
          // Entity.id = Entity.series ? Entity.series : Entity.id;
          await AV.Event.unCancelEvent(AV.AVEntity.getFk(Entity));
          Entity.status = null;
          entitydatalist[
            entitydatalist.indexOf(
              entitydatalist?.find((x) => x?.id === Entity?.id),
            )
          ] = Entity;

          let data: any = currentUser.events?.filter(
            (x) => x?.id == Entity?.id,
          );
          if (data) {
            data[0].status = null;
            data[0].data = null;
            let finalUser = await AV.Person.getSelf(true);
            dispatch(setUser(finalUser));
          }

          dispatch(setEntitydata(entitydatalist));
          setLoader(false);
          setIsShowEdit(false);
          navigate(
            `/Events/${Entity?.id}/${Entity?.region}/${params?.seriesId}`,
            { state: { team: Entity } },
          );
        }
      } catch (e) {
        console.log("Error in Un-cancel Event", e);
      } finally {
        setLoader(false);
      }
    };

    return (
      <>
        <HStack space={2} alignItems="center">
          {isCanceled && (
            <HStack alignSelf={"center"} space={2}>
              <Text color={"red.500"} fontSize={"18px"} fontWeight={500}>
                {Loc.currentLang.menu.canceled
                  ? Loc.currentLang.menu.canceled
                  : "Canceled"}
              </Text>
            </HStack>
          )}

          {!isCanceled && (
            <HStack ref={menuRef}>
              <Button
                minWidth="100px"
                bgColor="#32AE78"
                rounded="full"
                fontWeight="550px"
                color="#fff"
                p={2}
                justifyContent="flex-start"
                height="40px"
                borderRadius="20px"
                isLoading={isRsvpLoading}
                borderColor="AVColor.primary"
                onPress={() => setIsActives(!isActives)}
                isDisabled={
                  (!editAccess && !isEntireSeriesAvailable) ||
                  !isParticipantPercent
                }
              >
                <Text
                  color="white"
                  lineHeight="2rem"
                  paddingLeft="13px"
                  maxW={["130px"]}
                  text-overflow="ellipsis"
                  numberOfLines={1}
                  fontWeight={500}
                  fontSize="16px"
                >
                  {participantStatus
                    ? participantStatus === "Yes"
                      ? Loc.currentLang.menu.attending
                      : participantStatus === "No"
                        ? Loc.currentLang.menu.notAttending
                        : Loc.currentLang.menu.mayBe
                    : Loc.currentLang.menu.rsvp}
                </Text>
              </Button>

              {!isRsvpLoading && (
                <Pressable
                  position="absolute"
                  top="12px"
                  right="10px"
                  onPress={() => setIsActives(!isActives)}
                  disabled={!editAccess && !isEntireSeriesAvailable}
                >
                  <Image source={Dropdown} alt="Actavivo" size="15px" />
                </Pressable>
              )}
            </HStack>
          )}

          {isCanceled &&
            (isAdminView || isEventOwner) &&
            (editAccess || isEntireSeriesAvailable) && (
              <Button
                minWidth="100px"
                marginLeft={"15px"}
                bgColor="#32AE78"
                rounded="full"
                fontWeight="550px"
                color="#fff"
                p={2}
                height="40px"
                borderRadius="20px"
                isLoading={isLoader}
                borderColor="AVColor.primary"
                onPress={handleUncancelEvent}
                disabled={!editAccess && !isEntireSeriesAvailable}
              >
                <Text color="white" fontWeight="medium">
                  {Loc.currentLang.menu.restoreEvent}
                </Text>
              </Button>
            )}

          <HStack>
            {isActives && (
              <HStack
                ref={menuRef}
                position="absolute"
                top={5}
                right={0}
                flexDirection="column"
                width="120px"
                left="-112px"
                borderRadius="5px"
                bgColor="#FFFFFF"
                shadow="9"
                rounded="lg"
                zIndex={999}
              >
                <Button
                  onPress={() => {
                    if (params?.seriesId && entity?.seriesEvents?.length > 1) {
                      setIsShowEditOccurence(editAccess);
                      setIsShowEditEntireSeries(
                        editAccess || isEntireSeriesAvailable,
                      );
                    } else {
                      handleUpdateParticipant("Yes", true);
                    }
                    setIsUpdateRSVPStatus("Yes");
                    setIsActives(!isActives);
                  }}
                  bgColor="#FFFFFF"
                  height="30px"
                  justifyContent="start"
                  zIndex={999}
                  _hover={{ backgroundColor: "AVColor.hovercolor" }}
                  width="120px"
                >
                  <Text color="black">{Loc.currentLang.menu.attending}</Text>
                </Button>

                <Button
                  onPress={() => {
                    if (params?.seriesId && entity?.seriesEvents?.length > 1) {
                      setIsShowEditOccurence(editAccess);
                      setIsShowEditEntireSeries(
                        editAccess || isEntireSeriesAvailable,
                      );
                    } else {
                      handleUpdateParticipant("No", true);
                    }
                    setIsUpdateRSVPStatus("No");
                    setIsActives(!isActives);
                  }}
                  bgColor="#FFFFFF"
                  height="30px"
                  justifyContent="start"
                  zIndex={999}
                  _hover={{ backgroundColor: "AVColor.hovercolor" }}
                  width="120px"
                >
                  <Text color="black">{Loc.currentLang.menu.notAttending}</Text>
                </Button>

                <Button
                  bgColor="#FFFFFF"
                  height="30px"
                  justifyContent="start"
                  zIndex={999}
                  _hover={{ backgroundColor: "AVColor.hovercolor" }}
                  width="120px"
                  onPress={() => {
                    if (params?.seriesId && entity?.seriesEvents?.length > 1) {
                      setIsShowEditOccurence(editAccess);
                      setIsShowEditEntireSeries(
                        editAccess || isEntireSeriesAvailable,
                      );
                    } else {
                      handleUpdateParticipant("Maybe", true);
                    }
                    setIsUpdateRSVPStatus("Maybe");
                    setIsActives(!isActives);
                  }}
                >
                  <Text color="black">{Loc.currentLang.menu.mayBe}</Text>
                </Button>
              </HStack>
            )}
          </HStack>

          {!isCanceled && isAdminView && (
            <Pressable
              width="40px"
              height="40px"
              alignItems="center"
              justifyContent="center"
              bg="gray.100"
              _hover={{ bg: "gray.50" }}
              rounded="full"
              onPress={() => setOpenMenu(!openMenu)}
            >
              <MoreHorizontalIcon
                size="24px"
                color={"AVColor.primaryText"}
                alignSelf={"center"}
              />
            </Pressable>
          )}

          {openMenu && (
            <VStack
              ref={menuRef}
              width={"128x"}
              height="auto"
              shadow={2}
              background={"#FFFFFF"}
              position={"absolute"}
              top={8}
              right={0}
              zIndex={999}
              borderRadius={"6px"}
            >
              {(editAccess || isEntireSeriesAvailable) && (
                <Pressable
                  ref={menuRef}
                  width={"100%"}
                  height={"36px"}
                  paddingX={"10px"}
                  alignItems={"flex-start"}
                  justifyContent={"center"}
                  onPress={() => {
                    if (params?.seriesId && entity?.seriesEvents?.length > 1) {
                      setIsShowEditOccurence(editAccess);
                      setIsShowEditEntireSeries(
                        editAccess || isEntireSeriesAvailable,
                      );
                    } else {
                      setIsShowEdit(true);
                    }
                    setIsOpen(false);
                    setOpenMenu(false);
                  }}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                >
                  <Text fontSize={"14px"} fontFamily={"Roboto"}>
                    {Loc.currentLang.menu.edit}
                  </Text>
                </Pressable>
              )}

              {(editAccess || isEntireSeriesAvailable) && <Divider />}

              <Pressable
                ref={menuRef}
                width={"100%"}
                height={"36px"}
                paddingX={"10px"}
                alignItems={"flex-start"}
                justifyContent={"center"}
                onPress={() => {
                  Entity?.type == "Person" || Entity?.type == "Pet"
                    ? navigate(
                        `/accountsettings/${currentUser?.id}/${currentUser?.region}`,
                        {
                          state: {
                            page: "Home",
                          },
                        },
                      )
                    : navigate(
                        `/accountsettings/${Entity?.id}/${Entity?.region}`,
                        {
                          state: {
                            page: pathName,
                            Entity: Entity,
                          },
                        },
                      );
                }}
                _hover={{
                  backgroundColor: "gray.100",
                }}
              >
                <Text fontSize={"14px"} fontFamily={"Roboto"}>
                  {Loc.currentLang.menu.setting}
                </Text>
              </Pressable>
            </VStack>
          )}

          {(isShowEditOccurence || isShowEditEntireSeries) && (
            <VStack
              ref={menuRef}
              width={"128x"}
              height="auto"
              shadow={2}
              background={"#FFFFFF"}
              position={"absolute"}
              top={"30px"}
              zIndex={999}
              borderRadius={"6px"}
            >
              {isShowEditOccurence && (
                <Pressable
                  ref={menuRef}
                  width={"100%"}
                  height={"36px"}
                  paddingX={"10px"}
                  alignItems={"flex-start"}
                  justifyContent={"center"}
                  onPress={() => {
                    setIsEditEntireSeries(false);
                    isUpdateRSVPStatus == "Yes"
                      ? handleUpdateParticipant("Yes", false)
                      : isUpdateRSVPStatus == "No"
                        ? handleUpdateParticipant("No", false)
                        : isUpdateRSVPStatus == "Maybe"
                          ? handleUpdateParticipant("Maybe", false)
                          : setIsShowEdit(true);
                    setIsOpen(false);

                    setIsShowEditOccurence(false);
                    setIsShowEditEntireSeries(false);
                  }}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                >
                  <Text fontSize={"14px"} fontFamily={"Roboto"}>
                    {Loc.currentLang.menu.thisOccurrence}
                  </Text>
                </Pressable>
              )}

              {isShowEditOccurence && <Divider />}

              {isShowEditEntireSeries && (
                <Pressable
                  ref={menuRef}
                  width={"100%"}
                  height={"36px"}
                  paddingX={"10px"}
                  alignItems={"flex-start"}
                  justifyContent={"center"}
                  onPress={() => {
                    setIsEditEntireSeries(true);
                    isUpdateRSVPStatus == "Yes"
                      ? handleUpdateParticipant("Yes", true)
                      : isUpdateRSVPStatus == "No"
                        ? handleUpdateParticipant("No", true)
                        : isUpdateRSVPStatus == "Maybe"
                          ? handleUpdateParticipant("Maybe", true)
                          : setIsShowEdit(true);
                    setIsOpen(false);

                    setIsShowEditOccurence(false);
                    setIsShowEditEntireSeries(false);
                  }}
                  _hover={{
                    backgroundColor: "gray.100",
                  }}
                >
                  <Text fontSize={"14px"} fontFamily={"Roboto"}>
                    {Loc.currentLang.menu.entireSeries}
                  </Text>
                </Pressable>
              )}
            </VStack>
          )}
        </HStack>
      </>
    );
  };

  const handleMatriculate = async () => {
    try {
      // Clone the current entity list from Redux
      const updatedList = [...entitydatalist];

      // Helper to update an entity inside the local list
      const updateEntityInList = (updatedEntity: any) => {
        const idx = updatedList.findIndex((x) => x?.id === updatedEntity?.id);
        if (idx !== -1) updatedList[idx] = updatedEntity;
      };

      // Find or fetch the parent entity (School)
      let parentEntity: any | undefined;
      const foundParent = entitydatalist?.find(
        (x) => x?.id === Entity?.parent?.id,
      );
      parentEntity =
        foundParent ?? (await AV.AVEntity.get(Entity?.parent as AV.IFK));

      if (!parentEntity) {
        console.error("Parent entity not found.");
        return;
      }

      // Find the Alumni entity under the parent
      const alumni = parentEntity.childOrgs?.find(
        (x) => x.subType === "Alumni",
      );

      if (!alumni) {
        console.error("Alumni entity not found under parent.");
        return;
      }

      //// Reparent the Grad Class to Alumni using Save API
      //let gradClassEntity: any = {
      //  ...Entity,
      //  parent: alumni,
      //};

      //gradClassEntity = await AV.AVEntity.save(gradClassEntity);

      // Remove the Grad Class from its old parent using RemoveChild API
      parentEntity = await AV.Team.removeSeason(
        AV.AVEntity.getFk(parentEntity),
        AV.AVEntity.getFk(Entity), //AV.AVEntity.getFk(gradClassEntity),
      );

      //// If Matriculate is triggered from SchoolYear - remove GradClass from that SchoolYear
      //let yearEntity: any | undefined;
      ////const foundYearEntity = entitydatalist?.find(
      ////  (x) => x.id === parentEntity?.parent?.id,
      ////);
      ////yearEntity =
      ////  foundYearEntity ?? (await AV.AVEntity.get(Entity?.parent as AV.IFK));

      //yearEntity = parentEntity?.childOrgs?.filter(x => x.type === "SchoolYear");

      //if (yearEntity?.length > 0) {
      //  const schoolYearEntity: any = await AV.Club.removeGradClassFromYear(
      //    AV.AVEntity.getFk(yearEntity[0]),
      //    AV.AVEntity.getFk(gradClassEntity),
      //  );

      //  // Update year entity in the list
      //  updateEntityInList(schoolYearEntity);
      //}

      // Add the Grad Class to Alumni’s childOrgs using AddChild API
      const alumniEntity = await AV.Club.addTeam(
        AV.AVEntity.getFk(alumni),
        AV.AVEntity.getFk(Entity),
      );

      // Update local entity list and Redux
      updateEntityInList(alumniEntity);
      updateEntityInList(parentEntity);
      //updateEntityInList(gradClassEntity);
      dispatch(setEntitydata(updatedList));
    } catch (error) {
      console.error("Error during matriculate action:", error);
    }
  };

  const handleCollectPayHelcim = async () => {
    try {
      setIsLoadingPay(true);
      setIsShowPayPopup(false);
      const amount = parseFloat(payAmount.replace("$", ""));

      if (isNaN(amount) || amount <= 0) {
        throw new Error("Invalid amount selected.");
      }

      // Construct CollectOptions
      const collectOptions: AV.ICollectOptions = {
        collectReason: "F", // "F" for Fee
        personAmount: amount,
        currency: "USD",
        collectType: "Members",
        showPersonResults: false,
        trackByPerson: false,
        chargeFee: false,
        perPersonFee: false,
        target: Entity
          ? AV.AVEntity.getLink(Entity as AV.IAVEntity)
          : AV.AVEntity.getLink(currentUser as AV.IAVEntity),
      };

      // Get payment token
      const token = await AV.Pay.createPayment(collectOptions);

      if (token) {
        // Initialize Helcim payment
        await initHelcimPayment(
          token,
          amount,
          currentUser?.email || "",
          currentUser?.name || "",
        );
      } else {
        setIsLoadingPay(false);
        throw new Error("Failed to create payment token");
      }
      setIsLoadingPay(false);
    } catch (error) {
      console.error("Error creating payment:", error);
    }
  };

  //#region HelcimPayment Section

  // Add these variables at component level
  const [initData, setInitData] = useState<AV.IPayInitResp | null>(null);
  const [verify, setVerify] = useState<AV.IPayResultResp | null>(null);
  const tokenRef = useRef<string | null>(null);

  // Use ref to keep latest initData for use in event listener
  const initDataRef = useRef<AV.IPayInitResp | null>(null);
  useEffect(() => {
    initDataRef.current = initData;
  }, [initData]);

  // NOTE: Add Helcim script only once globally (public/index.html) – avoid TOKEN_LENGTH redeclare error.

  // Add event listener once on mount
  useEffect(() => {
    window.addEventListener("message", handleHelcimResponse);
    return () => {
      window.removeEventListener("message", handleHelcimResponse);
    };
  }, []);

  const initHelcimPayment = async (
    token: string,
    amount: number,
    email: string,
    name: string,
  ) => {
    try {
      setPageLoader(true);
      tokenRef.current = token;

      const response = await fetch("/api/pay/HInit", {
        method: "POST",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify({ token, amount, email, name }),
      });

      const data = await response.json();
      setInitData(data); // update state
      initDataRef.current = data; // keep ref in sync

      appendHelcimPayIframe(data.checkoutToken, true);

      setTimeout(() => {
        setPageLoader(false);
      }, 5000);
    } catch (error) {
      console.error("Payment initialization failed:", error);
      setPageLoader(false);
      throw error;
    }
  };

  const handleHelcimResponse = async (event: MessageEvent) => {
    const currentInitData = initDataRef.current;
    if (!currentInitData) return;

    const expectedKey = "helcim-pay-js-" + currentInitData.checkoutToken;

    if (event.data.eventName === expectedKey) {
      const status = event.data.eventStatus;
      const message = event.data.eventMessage;

      if (status === "ABORTED") {
        console.warn("Transaction aborted:", message);
      }

      if (status === "SUCCESS") {
        console.log("Transaction success:", message);
        try {
          const response = JSON.parse(message).data;

          await handlePaymentResult({
            checkoutToken: currentInitData.checkoutToken,
            data: response,
          });
        } catch (err) {
          console.error(
            "Failed parsing or handling Helcim success message:",
            err,
          );
        }
      }
    }
  };

  const handlePaymentResult = async (paymentData: PaymentData) => {
    try {
      const payload = {
        token: tokenRef.current ?? "",
        checkoutToken: paymentData.checkoutToken,
        data: {
          hash: paymentData.data.hash,
          data: JSON.stringify(paymentData.data.data),
        },
      };

      const response = await fetch("/api/pay/HResult", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      console.log("Payment verification result:", result);
      setVerify(result);

      if (result?.status === "OK") {
        console.log("Payment verified successfully");
      } else {
        console.warn("Payment verification failed on backend");
      }

      const index = Entity?.participants?.findIndex(
        (x) => x?.id === currentUser?.id,
      );

      if (index !== -1) {
        const updatedParticipants = [...Entity.participants];
        const participant = { ...updatedParticipants[index] };

        // Ensure donations array exists
        let donations = participant.donantions || [];

        // Find existing donation (same user)
        const donationIndex = donations.findIndex(
          (d) => d?.id === currentUser?.id,
        );

        if (donationIndex !== -1) {
          // Update existing donation
          donations[donationIndex] = {
            ...donations[donationIndex],
            amount:
              Number(donations[donationIndex].amount || 0) + Number(payAmount),
          };
        } else {
          // Add new donation
          donations.push({
            id: currentUser?.id,
            amount: Number(payAmount),
            title: currentUser?.name,
            region: currentUser?.region,
            type: currentUser?.type,
          });
        }

        participant.donantions = donations;
        participant.amount = (participant.amount || 0) + Number(payAmount);

        updatedParticipants[index] = participant;

        const updatedEntity = {
          ...Entity,
          participants: updatedParticipants,
        };

        setEntity?.(updatedEntity);

        const entityIndex = entitydatalist?.findIndex(
          (x) => x?.id === Entity?.id,
        );

        if (entityIndex !== -1) {
          const updatedList = [...entitydatalist];
          updatedList[entityIndex] = updatedEntity;
          dispatch(setEntitydata(updatedList));
        }
      }

      setIsShowPayPopup(false);
      // Remove the HelcimPay.js iframe from the DOM
      const iframe = document.querySelector("iframe[src*='helcim']");
      if (iframe && iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    } catch (error) {
      console.error("Payment verification failed (frontend):", error);
      // Remove the HelcimPay.js iframe from the DOM
      const iframe = document.querySelector("iframe[src*='helcim']");
      if (iframe && iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    }
  };

  //#endregion HelcimPayment Section

  const checkExpired = (date?: string | Date): boolean => {
    if (!date) return false;

    const targetDate = typeof date === "string" ? new Date(date) : date;
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    targetDate.setHours(0, 0, 0, 0);

    const diffTime = targetDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays < 0;
  };

  const isSelfDeletedUser =
    (Entity?.type === "Person" || Entity?.type === "Pet") &&
    Entity?.status === "Deleted" &&
    userID === Entity?.id;

  const isAdminHiddenUser =
    isAdminView &&
    !participantUser &&
    Entity?.id !== "78b5b063-fd3e-4925-92bd-2a1888c6a46a" &&
    Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa7f" &&
    Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa71" &&
    Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa72" &&
    EntityType?.status !== "Canceled";

  return (
    <>
      <Box
        height={"auto"}
        zIndex={-3}
        backgroundColor={"AVColor.white"}
        shadow={1}
        borderTopLeftRadius={10}
        borderTopRightRadius={10}
      >
        <Box
          height={
            type === "Feedback"
              ? "140px"
              : Entity?.type === "Event" &&
                  !Entity?.profile?.background?.id &&
                  !isShowEdit
                ? "95px"
                : Entity?.type === "Event" &&
                    !Entity?.profile?.background?.id &&
                    isShowEdit
                  ? "42px"
                  : "230px"
          }
          backgroundColor={
            Entity?.type === "Event" && !Entity?.profile?.background?.id
              ? "white"
              : "AVColor.hovercolor2"
          }
          borderTopLeftRadius={10}
          borderTopRightRadius={10}
        >
          {/*Background*/}
          <AVCoverPic
            Entity={Entity}
            setEntity={setEntity}
            openPreview={openPreview}
            isShowEdit={isShowEdit}
            handleUpload={handleUpload}
            profile={profile}
            isCreate={isCreate}
            setProfile={setProfile}
            type={type}
            isAdminView={isAdminView}
            editAccess={editAccess || isEntireSeriesAvailable}
            isShowPicker={isShowPicker}
            setIsShowpicker={setIsShowpicker}
            imageLoader={imageLoader}
            setImageLoader={setImageLoader}
          />

          {/*Follow and FavouriteIcon*/}
          {!isCreate && !isShowEdit && isDeleted && (
            <Box
              width={"100%"}
              alignItems={"flex-end"}
              right={"27px"}
              top={
                Entity?.type === "Event" && !Entity?.profile?.background?.id
                  ? "37px"
                  : "25px"
              }
            >
              <HStack space={3}>
                {/* Follow */}
                {Entity?.type !== "Collect" &&
                  !isFollowing &&
                  !requestSent &&
                  !isAdminView &&
                  currentUser?.autoFollows?.filter((x) => x?.id === Entity?.id)
                    ?.length == 0 &&
                  currentUser?.id !== Entity?.id &&
                  EntityType?.type !== "Event" && (
                    <Tooltip
                      openDelay={500}
                      label={Loc.currentLang.follow.follow}
                    >
                      <Button
                        width={"40px"}
                        height={"40px"}
                        rounded={"full"}
                        onPress={() => {
                          handleFollowProfile("follow", Entity?.name ?? "");
                        }}
                        isLoading={followRequestSending}
                      >
                        <AddIcon size={"22px"} color={"AVColor.white"} />
                      </Button>
                    </Tooltip>
                  )}

                {/*Request sent*/}
                {Entity?.type !== "Collect" &&
                  requestSent &&
                  !isAdminView &&
                  Entity?.type !== "Pet" &&
                  currentUser?.id !== Entity?.id &&
                  EntityType?.type !== "Event" && (
                    <Button
                      pl={2}
                      pr={4}
                      py={2}
                      borderRadius={"45px"}
                      minWidth={"120px"}
                      bgColor={"AVColor.buttonBg"}
                      _text={{ color: "AVColor.primaryText" }}
                    >
                      {Loc.currentLang.menu.requestSent}
                    </Button>
                  )}

                {/*FavouriteIcon*/}
                {Entity?.type !== "Collect" &&
                  !isMyFavourite &&
                  currentUser?.id !== Entity?.id &&
                  Entity?.type !== "Event" && (
                    <Tooltip
                      openDelay={500}
                      label={Loc.currentLang.menu.favourite}
                    >
                      <Button
                        width={"40px"}
                        height={"40px"}
                        rounded={"full"}
                        isLoading={isFavLoader}
                        onPress={() => handleFavourite("addFavourite")}
                      >
                        <FavouriteIcon size={"22px"} color={"AVColor.white"} />
                      </Button>
                    </Tooltip>
                  )}

                {Entity?.type !== "Collect" &&
                  currentUser?.id !== Entity?.id &&
                  Entity?.type !== "Event" &&
                  Entity?.id !== "78b5b063-fd3e-4925-92bd-2a1888c6a46a" &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa7f" &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa71" &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa72" &&
                  (isMemberOfEntity ||
                    isPlayerOfEntity ||
                    isstaffOfEntity ||
                    ((Entity?.type == "Person" || Entity?.type == "Pet") &&
                      currentUser?.id !== Entity?.id)) && (
                    <Tooltip
                      openDelay={500}
                      label={Loc.currentLang.activity.chat}
                    >
                      <Offline>
                        {({ isOffline }) => (
                          <Button
                            width={"40px"}
                            height={"40px"}
                            isDisabled={isOffline}
                            rounded={"full"}
                            onPress={() =>
                              HandleGroupChat(
                                Entity?.type == "PlayerOrg" &&
                                  Entity?.subType == undefined
                                  ? "A"
                                  : "W",
                              )
                            }
                            backgroundColor={"#18A6B9"}
                            isLoading={isLoad}
                          >
                            <GroupChatIcon size={23} color={"white"} />
                          </Button>
                        )}
                      </Offline>
                    </Tooltip>
                  )}

                {Entity?.type === "Event" && (
                  <>
                    <RenderRsvp entity={Entity} />
                  </>
                )}

                {((Entity?.type !== "Event" && Entity?.type !== "Collect") ||
                  (Entity?.type === "Collect" && !checkExpired(Entity?.end))) &&
                  isAdminView &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa7f" &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa71" &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa72" && (
                    <Pressable
                      width="40px"
                      height="40px"
                      alignItems="center"
                      justifyContent="center"
                      bg="gray.100"
                      _hover={{ bg: "gray.50" }}
                      rounded="full"
                      onPress={() => setIsOpen(!isOpen)}
                    >
                      <MoreHorizontalIcon
                        size="24px"
                        color={"AVColor.primaryText"}
                        alignSelf={"center"}
                      />
                    </Pressable>
                  )}

                {!isAdminView &&
                  Entity?.type !== "Event" &&
                  Entity?.type !== "Collect" &&
                  Entity?.status !== "Canceled" &&
                  Entity?.id !== "78b5b063-fd3e-4925-92bd-2a1888c6a46a" &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa7f" &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa71" &&
                  Entity?.id !== "b495d4e0-bf52-4690-8dc0-677db954aa72" && (
                    <Pressable
                      width="40px"
                      height="40px"
                      alignItems="center"
                      justifyContent="center"
                      bg="gray.100"
                      _hover={{ bg: "gray.50" }}
                      rounded="full"
                      onPress={(e) => {
                        e.stopPropagation();
                        setIsOpen(!isOpen);
                      }}
                    >
                      <MoreHorizontalIcon
                        size="24px"
                        color={"AVColor.primaryText"}
                        alignSelf={"center"}
                      />
                    </Pressable>
                  )}
              </HStack>

              {!isAdminView &&
                Entity?.type === "Collect" &&
                !isCollectFullyPaid && (
                  <Offline>
                    {({ isOffline }) => (
                      <Button
                        width={"100px"}
                        height="auto"
                        backgroundColor="#32AE78"
                        rounded="full"
                        onPress={() => setIsShowPayPopup(true)}
                      >
                        <Text color="white">
                          {Loc.currentLang.feeCollect.payCaps}
                        </Text>
                      </Button>
                    )}
                  </Offline>
                )}

              {Entity?.type !== "Event" && isOpen && isAdminView && (
                <VStack
                  ref={menuRef}
                  width={"130px"}
                  height="auto"
                  shadow={2}
                  background={"#FFFFFF"}
                  position={"absolute"}
                  top={"30px"}
                  zIndex={999}
                  borderRadius={"6px"}
                >
                  {Entity?.type !== "Collect" &&
                  Entity?.parent?.type === "School" &&
                  Entity?.subType == "GradClass" ? (
                    <>
                      <Pressable
                        ref={menuRef}
                        width={"100%"}
                        height={"36px"}
                        paddingX={"10px"}
                        alignItems={"flex-start"}
                        justifyContent={"center"}
                        onPress={async () => {
                          try {
                            setLoader(true);
                            await handleMatriculate();
                          } finally {
                            setLoader(false);
                            setIsOpen(!isOpen);
                          }
                        }}
                        _hover={{
                          backgroundColor: "gray.100",
                        }}
                        isDisabled={isLoader}
                      >
                        {isLoader ? (
                          <HStack alignItems="center" space={2}>
                            <Spinner size="sm" color="AVColor.primary" />
                            <Text fontSize={"14px"} fontFamily={"Roboto"}>
                              {Loc.currentLang.menu.matriculating}
                            </Text>
                          </HStack>
                        ) : (
                          <Text fontSize={"14px"} fontFamily={"Roboto"}>
                            {Loc.currentLang.menu.matriculate}
                          </Text>
                        )}
                      </Pressable>

                      <Divider />

                      <Pressable
                        ref={menuRef}
                        width={"100%"}
                        height={"36px"}
                        paddingX={"10px"}
                        alignItems={"flex-start"}
                        justifyContent={"center"}
                        onPress={() => {
                          navigate(
                            `/accountsettings/${Entity?.id}/${Entity?.region}`,
                            {
                              state: {
                                page: pathName,
                                Entity: Entity,
                              },
                            },
                          );
                        }}
                        _hover={{
                          backgroundColor: "gray.100",
                        }}
                      >
                        <Text fontSize={"14px"} fontFamily={"Roboto"}>
                          {Loc.currentLang.menu.setting}
                        </Text>
                      </Pressable>
                    </>
                  ) : (
                    <>
                      <Pressable
                        ref={menuRef}
                        width={"100%"}
                        height={"36px"}
                        paddingX={"10px"}
                        alignItems={"flex-start"}
                        justifyContent={"center"}
                        onPress={() => {
                          Entity?.series && seriesEventData
                            ? setIsShowEditOccurence(true)
                            : setIsShowEdit(true);
                          setIsOpen(false);
                        }}
                        _hover={{
                          backgroundColor: "gray.100",
                        }}
                      >
                        <Text fontSize={"14px"} fontFamily={"Roboto"}>
                          {Loc.currentLang.menu.edit}
                        </Text>
                      </Pressable>

                      {Entity?.type !== "Collect" && (
                        <>
                          <Divider />

                          <Pressable
                            ref={menuRef}
                            width={"100%"}
                            height={"36px"}
                            paddingX={"10px"}
                            alignItems={"flex-start"}
                            justifyContent={"center"}
                            onPress={() => {
                              Entity?.type == "Person" || Entity?.type == "Pet"
                                ? navigate(
                                    `/accountsettings/${currentUser?.id}/${currentUser?.region}`,
                                    {
                                      state: {
                                        page: "Home",
                                      },
                                    },
                                  )
                                : navigate(
                                    `/accountsettings/${Entity?.id}/${Entity?.region}`,
                                    {
                                      state: {
                                        page: pathName,
                                        Entity: Entity,
                                      },
                                    },
                                  );
                            }}
                            _hover={{
                              backgroundColor: "gray.100",
                            }}
                          >
                            <Text fontSize={"14px"} fontFamily={"Roboto"}>
                              {Loc.currentLang.menu.setting}
                            </Text>
                          </Pressable>
                        </>
                      )}
                    </>
                  )}
                </VStack>
              )}

              {isOpen &&
                !isAdminView &&
                Entity?.type !== "Person" &&
                Entity?.type !== "Pet" &&
                Entity?.type !== "Event" &&
                Entity?.type !== "Collect" && (
                  <VStack
                    width={"185x"}
                    height="auto"
                    shadow={2}
                    background={"#FFFFFF"}
                    position={"absolute"}
                    top={"50px"}
                    zIndex={999}
                    borderRadius={"6px"}
                    ref={menuRef}
                  >
                    <Pressable
                      width={"100%"}
                      height={"36px"}
                      paddingX={"5px"}
                      paddingY={"5px"}
                      _hover={{
                        backgroundColor: "gray.100",
                      }}
                      alignItems={"flex-start"}
                      justifyContent={"center"}
                      onPress={() => {
                        setIsStaffReq(true);
                        setIsOpen(false);
                      }}
                    >
                      <Text fontSize={"14px"} fontFamily={"Roboto"}>
                        {Loc.currentLang.menu.requestToJoinStaff}
                      </Text>
                    </Pressable>

                    <Divider />

                    <Pressable
                      width={"100%"}
                      height={"36px"}
                      paddingX={"5px"}
                      paddingY={"5px"}
                      _hover={{
                        backgroundColor: "gray.100",
                      }}
                      alignItems={"flex-start"}
                      justifyContent={"center"}
                      onPress={() => {
                        setIsChildOrgReq(true);
                        setIsOpen(false);
                      }}
                    >
                      <Text
                        paddingX={1}
                        numberOfLines={2}
                        fontSize={"14px"}
                        fontFamily={"Roboto"}
                      >
                        {Loc.currentLang.menu.requestToAddChildOrganization
                          ? Loc.currentLang.menu.requestToAddChildOrganization
                          : "Request to Add ChilOrganization"}
                      </Text>
                    </Pressable>
                  </VStack>
                )}

              {isOpen &&
                !isAdminView &&
                (Entity?.type == "Person" || Entity?.type == "Pet") && (
                  <VStack
                    ref={menuRef}
                    width={"128px"}
                    height="auto"
                    shadow={2}
                    background={"#FFFFFF"}
                    position={"absolute"}
                    top={"24px"}
                    zIndex={999}
                    borderRadius={"6px"}
                  >
                    {!isBlock ? (
                      <Button
                        width={"100%"}
                        height={"36px"}
                        paddingX={"10px"}
                        alignItems={"flex-start"}
                        _hover={{
                          backgroundColor: "gray.100",
                        }}
                        justifyContent={"center"}
                        backgroundColor={isBlockLoad ? "gray.500" : ""}
                        isLoading={isBlockLoad}
                        onPress={() => {
                          HandleBlockUser("block", Entity?.name ?? "");
                          setIsOpen(false);
                        }}
                      >
                        <Text fontSize={"14px"} fontFamily={"Roboto"}>
                          {Loc.currentLang.follow.block}
                        </Text>
                      </Button>
                    ) : (
                      <Button
                        width={"100%"}
                        height={"36px"}
                        paddingX={"10px"}
                        _hover={{
                          backgroundColor: "gray.100",
                        }}
                        alignItems={"flex-start"}
                        justifyContent={"center"}
                        backgroundColor={isBlockLoad ? "gray.500" : ""}
                        onPress={() => {
                          HandleUnBlockUser("unblock", Entity?.name ?? "");
                          setIsOpen(false);
                        }}
                        isLoading={isBlockLoad}
                      >
                        <Text fontSize={"14px"} fontFamily={"Roboto"}>
                          {Loc.currentLang.follow.unBlock}
                        </Text>
                      </Button>
                    )}

                    {currentUser?.follows?.filter((x) => x?.id == Entity?.id)
                      ?.length > 0 && (
                      <Button
                        width={"100%"}
                        height={"36px"}
                        paddingX={"10px"}
                        alignItems={"flex-start"}
                        _hover={{
                          backgroundColor: "gray.100",
                        }}
                        backgroundColor={isBlockLoad ? "gray.500" : ""}
                        justifyContent={"center"}
                        onPress={() => {
                          handleFollowProfile("unfollow", Entity?.name ?? "");
                          setIsOpen(false);
                        }}
                      >
                        <Text fontSize={"14px"} fontFamily={"Roboto"}>
                          {Loc.currentLang.follow.unfollow}
                        </Text>
                      </Button>
                    )}
                  </VStack>
                )}
            </Box>
          )}
        </Box>

        {/*Profile*/}
        {EntityType?.type !== "Collect" && (
          <AVProfilePic
            isMyFavourite={isMyFavourite}
            isShowEdit={isShowEdit}
            EntityType={EntityType}
            handleFavourite={handleFavourite}
            Entity={Entity}
            isLoader={isFavLoader}
            handleUpload={handleUpload}
            profile={profile}
            isCreate={isCreate}
            setProfile={setProfile}
            type={type}
            isAdminView={isAdminView}
            editAccess={editAccess || isEntireSeriesAvailable}
            imageLoader={imageLoader}
            setImageLoader={setImageLoader}
            openPreview={openPreview}
          />
        )}

        {EntityType?.type === "Event" && !isShowEdit && (
          <VStack
            position={"absolute"}
            left={isMobile ? "187px" : "250px"}
            width={isShowPicker ? "15%" : "40%"}
            top={
              Entity?.type === "Event" && !Entity?.profile?.background?.id
                ? "35px"
                : "228px"
            }
            paddingTop={"12px"}
          >
            <HStack width={"100%%"}>
              <Text
                fontWeight={500}
                fontSize={"24px"}
                numberOfLines={1}
                width={"100%"}
              >
                {Entity?.name}
              </Text>
            </HStack>

            <HStack width={"100%"}>
              <Pressable
                width={"100%"}
                onPress={() => {
                  Owner?.type == "Person" || Owner?.type == "Pet"
                    ? navigate(`/profile/${Owner?.id}/${Owner?.region}`, {
                        state: {
                          user: {
                            id: Owner?.id,
                            pk: Owner?.pk,
                            region: Owner?.region,
                            type: Owner?.type,
                            name: Owner?.title,
                          },
                        },
                      })
                    : Owner?.type == "PlayerOrg"
                      ? navigate(`/season/${Owner?.id}/${Owner?.region}`, {
                          state: { isCreate: false, team: Owner },
                        })
                      : Owner?.type == "Team"
                        ? navigate(`/teams/${Owner?.id}/${Owner?.region}`, {
                            state: { isCreate: false, team: Owner },
                          })
                        : navigate(`/season/${Owner?.id}/${Owner?.region}`, {
                            state: { isCreate: false, team: Owner },
                          });
                }}
              >
                <Text
                  fontWeight={400}
                  fontSize={"16px"}
                  width={"100%"}
                  numberOfLines={1}
                  color={"#00A7BC"}
                >
                  {Owner?.type === "PlayerOrg"
                    ? Owner?.name?.trim()?.length > 0
                      ? Owner?.name
                      : Owner?.data || Owner?.title
                    : Owner?.title || Owner?.name}
                </Text>
              </Pressable>
            </HStack>
          </VStack>
        )}

        {/* Title*/}
        {!isCreate && !isShowEdit && (
          <VStack
            height={"auto"}
            marginTop={"55px"}
            marginBottom={Entity?.type == "Event" ? "" : "22px"}
            width={"100%"}
            zIndex={-3}
          >
            <AVHeaderTitle
              Entity={Entity}
              EntityType={EntityType}
              googlemap={googlemap}
              weatherURL={weatherURL}
              weather={weather}
              setIsImagePopup={setIsImagePopup}
              seriesEvent={seriesEvent}
              isAdminView={isAdminView}
              setClickedUrl={setClickedUrl}
              setShowConfirmLinkPopup={setShowConfirmLinkPopup}
            />

            {!isDeleted &&
              (Entity?.type == "Person" || Entity?.type == "Pet"
                ? !isAdminView
                : isAdminView) &&
              !isCreate &&
              !isShowEdit && (
                <HStack
                  justifyContent={"flex-end"}
                  marginTop={"24px"}
                  marginX={"24px"}
                >
                  {(isSelfDeletedUser || isAdminHiddenUser) && (
                    <Button
                      width={"246px"}
                      bgColor={"#32AE78"}
                      rounded="full"
                      color="#fff"
                      p={2}
                      justifyContent={"center"}
                      height={"40px"}
                      borderRadius={"20px"}
                      onPress={HandleRestoreAccount}
                    >
                      <Text color={"white"}>
                        {Loc.currentLang.menu.restoreyourAccount}
                      </Text>
                    </Button>
                  )}
                </HStack>
              )}

            {Entity?.status === "Deleted" &&
              !isDeleted &&
              (Entity?.type == "Person" || Entity?.type == "Pet"
                ? isAdminView
                : !isAdminView) &&
              !isCreate &&
              !isShowEdit && (
                <VStack alignItems={"center"} marginTop={"35px"}>
                  <img
                    src={Deleted}
                    alt="image"
                    height={"220px"}
                    width={"240px"}
                  />
                  <HStack paddingBottom={"8px"}>
                    <Text fontWeight={400} fontSize={"18px"}>
                      {Loc.currentLang.menu.noLongerTxt}
                    </Text>
                  </HStack>
                  <HStack>
                    <Text>{Loc.currentLang.menu.restrictPostTxt}</Text>
                  </HStack>
                </VStack>
              )}
          </VStack>
        )}
      </Box>

      {isShowPayPopup && (
        <Box
          position="fixed"
          bgColor="AVColor.overlay2"
          top={0}
          bottom={0}
          left={0}
          right={0}
          zIndex={99999}
        >
          <div
            className={`create_post_popup ${
              isMobile && "create_post_popup_mobile"
            }`}
            style={{
              width: isMobile ? dimensions.width - 15 : "565px",
              height: isMobile ? "650px" : "310px",
              marginTop: "12px",
            }}
          >
            <VStack width="100%" padding="24px" space={2}>
              {/* Header */}
              <HStack justifyContent="space-between" alignItems="center">
                <Text fontSize="24px" fontWeight="600">
                  {Entity?.name}
                </Text>

                <AVCancel
                  callback={() => {
                    setIsShowPayPopup(false);
                    //setPayAmount("");
                  }}
                  color={undefined}
                  size={undefined}
                />
              </HStack>

              {/* Description */}
              <Text fontSize="16px" color="coolGray.700">
                <Text
                  fontSize="14px"
                  color="coolGray.700"
                  noOfLines={2}
                  ellipsizeMode="tail"
                  marginBottom="16px"
                >
                  {Entity?.profile?.text ?? ""}
                </Text>
              </Text>

              {/* Remaining Amount */}
              <Text fontSize="16px" color="#32AE78">
                {`${Loc.currentLang.feeCollect.remainingAmount}: $${remainingAmount}`}
              </Text>

              {/* Input */}
              <Box width="95%" top="6px">
                <AVInputtext
                  type="text"
                  label={Loc.currentLang.feeCollect.enterAmount}
                  value={payAmount}
                  maxLength={7}
                  onChange={(e) => {
                    let input = e.target.value;

                    // Allow numbers and a single decimal point
                    input = input
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*)\./g, "$1");

                    // Limit to 2 decimal places
                    const parts = input.split(".");
                    if (parts[1]?.length > 2) {
                      input = `${parts[0]}.${parts[1].slice(0, 2)}`;
                    }

                    setPayAmount(input);
                  }}
                />
              </Box>

              {/* Action Button */}
              <HStack justifyContent="center" pt={2}>
                <Button
                  width="180px"
                  height="40px"
                  rounded="full"
                  backgroundColor="AVColor.primary"
                  isDisabled={
                    isLoadingPay ||
                    !payAmount?.trim() ||
                    Number(payAmount) <= 0 ||
                    Number(payAmount) > remainingAmount
                  }
                  isLoading={isLoadingPay}
                  onPress={handleCollectPayHelcim}
                >
                  <Text color="white" fontWeight="500">
                    {Loc.currentLang.feeCollect.doneCaps}
                  </Text>
                </Button>
              </HStack>
            </VStack>
          </div>
        </Box>
      )}
    </>
  );
};

export default memo(ProfileHeader);
